import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatAsGermanDate } from '~/functions/helpers';
import { impactResultCardEditPath } from '~/functions/impact-result-card-edit';
import { useListEvidenceLinksQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomImpactResults',
  props: {
    impact: null,
    ventureId: null,
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var impact = computed(function () {
      return props.impact;
    });
    var editPath = computed(function () {
      return impactResultCardEditPath(props.ventureId, impact.value);
    });
    var conceptLabel = computed(function () {
      var _impact$value, _impact$value$concept;
      return ((_impact$value = impact.value) === null || _impact$value === void 0 ? void 0 : (_impact$value$concept = _impact$value.concept) === null || _impact$value$concept === void 0 ? void 0 : _impact$value$concept.label) || String(proxy.$t('badge'));
    });
    var stakeholderLabel = computed(function () {
      var _impact$value2;
      return ((_impact$value2 = impact.value) === null || _impact$value2 === void 0 ? void 0 : _impact$value2.stakeholder) || '';
    });
    var stakeholderCategoryLabel = computed(function () {
      var _impact$value3;
      var category = (_impact$value3 = impact.value) === null || _impact$value3 === void 0 ? void 0 : _impact$value3.stakeholderCategory;
      if (!category) return null;
      return String(proxy.$t("impactGoal.impacts.defineImpacts.defineImpact.outcomeStakeholderDialog.stakeholder.".concat(category)));
    });
    var polarityLabel = computed(function () {
      var _impact$value4, _impact$value5;
      if (((_impact$value4 = impact.value) === null || _impact$value4 === void 0 ? void 0 : _impact$value4.isPositive) === true) return String(proxy.$t('positive'));
      if (((_impact$value5 = impact.value) === null || _impact$value5 === void 0 ? void 0 : _impact$value5.isPositive) === false) return String(proxy.$t('negative'));
      return null;
    });
    var problemText = computed(function () {
      var _impact$value6, _impact$value6$proble;
      return ((_impact$value6 = impact.value) === null || _impact$value6 === void 0 ? void 0 : (_impact$value6$proble = _impact$value6.problem) === null || _impact$value6$proble === void 0 ? void 0 : _impact$value6$proble.trim()) || '';
    });
    var theoryOfChangeText = computed(function () {
      var _impact$value7, _impact$value7$theory;
      return ((_impact$value7 = impact.value) === null || _impact$value7 === void 0 ? void 0 : (_impact$value7$theory = _impact$value7.theoryOfChange) === null || _impact$value7$theory === void 0 ? void 0 : _impact$value7$theory.trim()) || '';
    });
    var metricAssignments = computed(function () {
      var _impact$value$metricA, _impact$value8;
      return ((_impact$value$metricA = (_impact$value8 = impact.value) === null || _impact$value8 === void 0 ? void 0 : _impact$value8.metricAssignments) !== null && _impact$value$metricA !== void 0 ? _impact$value$metricA : []).filter(function (a) {
        return (a === null || a === void 0 ? void 0 : a.id) != null;
      });
    });
    var solutions = computed(function () {
      var _impact$value$impactS, _impact$value9;
      return (_impact$value$impactS = (_impact$value9 = impact.value) === null || _impact$value9 === void 0 ? void 0 : _impact$value9.impactSolutions) !== null && _impact$value$impactS !== void 0 ? _impact$value$impactS : [];
    });
    var solutionIds = computed(function () {
      return solutions.value.map(function (solution) {
        return solution.id;
      }).filter(function (id) {
        return typeof id === 'number';
      });
    });
    var evidenceVariables = computed(function () {
      return {
        filters: {
          accountId: props.ventureId,
          entityIntIds: solutionIds.value,
          type: 'impact-solution'
        },
        limit: 1000,
        offset: 0
      };
    });
    var _useListEvidenceLinks = useListEvidenceLinksQuery(evidenceVariables, computed(function () {
        return {
          enabled: solutionIds.value.length > 0
        };
      })),
      evidenceResult = _useListEvidenceLinks.result;
    function groupEvidenceByEntityId(evidenceLinks) {
      return (evidenceLinks !== null && evidenceLinks !== void 0 ? evidenceLinks : []).reduce(function (acc, evidenceLink) {
        if (!evidenceLink || evidenceLink.entityIntId == null) return acc;
        var entityId = evidenceLink.entityIntId;
        if (!acc[entityId]) acc[entityId] = [];
        acc[entityId].push(evidenceLink);
        return acc;
      }, {});
    }
    var evidenceBySolutionId = computed(function () {
      var _evidenceResult$value;
      return groupEvidenceByEntityId((_evidenceResult$value = evidenceResult.value) === null || _evidenceResult$value === void 0 ? void 0 : _evidenceResult$value.listEvidenceLinks);
    });
    function solutionEvidenceLinks(solutionId) {
      var _evidenceBySolutionId;
      if (solutionId == null) return [];
      return (_evidenceBySolutionId = evidenceBySolutionId.value[solutionId]) !== null && _evidenceBySolutionId !== void 0 ? _evidenceBySolutionId : [];
    }
    var hasFrameworkContent = computed(function () {
      var _impact$value$sdgTarg, _impact$value10, _impact$value10$sdgTa, _impact$value11, _impact$value$irisCat, _impact$value12, _impact$value12$irisC;
      return ((_impact$value$sdgTarg = (_impact$value10 = impact.value) === null || _impact$value10 === void 0 ? void 0 : (_impact$value10$sdgTa = _impact$value10.sdgTargets) === null || _impact$value10$sdgTa === void 0 ? void 0 : _impact$value10$sdgTa.length) !== null && _impact$value$sdgTarg !== void 0 ? _impact$value$sdgTarg : 0) > 0 || !!((_impact$value11 = impact.value) !== null && _impact$value11 !== void 0 && _impact$value11.euTaxonomy) || ((_impact$value$irisCat = (_impact$value12 = impact.value) === null || _impact$value12 === void 0 ? void 0 : (_impact$value12$irisC = _impact$value12.irisCategories) === null || _impact$value12$irisC === void 0 ? void 0 : _impact$value12$irisC.length) !== null && _impact$value$irisCat !== void 0 ? _impact$value$irisCat : 0) > 0;
    });
    var updatedOnLabel = computed(function () {
      var _impact$value13;
      var submitDate = (_impact$value13 = impact.value) === null || _impact$value13 === void 0 ? void 0 : _impact$value13.submitDate;
      if (!submitDate) return null;
      var formatted = formatAsGermanDate(String(submitDate));
      if (!formatted) return null;
      return String(proxy.$t('updatedOn', {
        date: formatted
      }));
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      impact: impact,
      editPath: editPath,
      conceptLabel: conceptLabel,
      stakeholderLabel: stakeholderLabel,
      stakeholderCategoryLabel: stakeholderCategoryLabel,
      polarityLabel: polarityLabel,
      problemText: problemText,
      theoryOfChangeText: theoryOfChangeText,
      metricAssignments: metricAssignments,
      solutions: solutions,
      solutionIds: solutionIds,
      evidenceVariables: evidenceVariables,
      evidenceResult: evidenceResult,
      groupEvidenceByEntityId: groupEvidenceByEntityId,
      evidenceBySolutionId: evidenceBySolutionId,
      solutionEvidenceLinks: solutionEvidenceLinks,
      hasFrameworkContent: hasFrameworkContent,
      updatedOnLabel: updatedOnLabel
    };
  }
});